import './helper_functions';
import './ai_crafted';
import './docus_common';
import './number_pages';
import './time_records_msb';
import './readable-range-de'
import './messages_compose';
import './messages_inbox';
import './messages_poll';
import './demo_generation_progress'; // 260721nrai
import './attachment_pdf_reveal'; // 260805nrai: /azs + attachment PDF reveal/PDFObject
import { initHeaderBecomeUser } from './header_become_user'; // 260807nrai: formless header become
import { initPersonHoverMenu, openPersonHoverMenu, bindSelectPersonHoverMenu } from './person_hover_menu'; // 260813nrai: person name hover cards
import { initPersonClientMatrix, fillPersonClientMatrixAvatars } from './person_client_matrix';
import { initPersonListLazyLoading } from './person_list_lazy';
import { initTimeRecordsJournalLazyLoading, initTimeRecordsJournalLazyDropdowns, constrainEmbeddedJournalLazyFilter } from './time_records_journal_lazy';
import { initEmployeeAvatarForm } from './employee_avatar';
import { applyAvatarPhoto } from './redfish';
import { initDocuWindowLeadRequest } from './time_records_docu_window_lead_request';
import { initAzReversalRequest, azStornoRequestOpen } from './azs_reversal_request';
import { initAzVerifyPdf, azVerifyPdfModalOpen, azVerifyPdfModalClose } from './azs_verify_pdf';
import { initAzSaldoHover } from './az_saldo_hover';
import { initVacationRequest, vacationRequestOpen, filter_time_record_workflow } from './time_records_vacation_request';
import { initTodosUi } from './todos';
import { initErrorReportsUi } from './error_reports'; // 260817nrai
import { initInstitutionResponsibilityFilters } from './institution_responsibilities'; // 260825nrai
import { crToggleMarks, crMarksSubmit, toggle_marks, initClientResponsibilityMarks } from './client_responsibilities_marks'; // 260911nrai
import { initCurrentUsersPage } from './current_users'; // 260911nrai

window.openPersonHoverMenu = openPersonHoverMenu;
window.bindSelectPersonHoverMenu = bindSelectPersonHoverMenu;
window.fillPersonClientMatrixAvatars = fillPersonClientMatrixAvatars;
window.initPersonListLazyLoading = initPersonListLazyLoading;
window.initTimeRecordsJournalLazyLoading = initTimeRecordsJournalLazyLoading;
window.initTimeRecordsJournalLazyDropdowns = initTimeRecordsJournalLazyDropdowns;
window.constrainEmbeddedJournalLazyFilter = constrainEmbeddedJournalLazyFilter;
window.applyAvatarPhoto = applyAvatarPhoto;

// --------------------------------------------------------------
// ---------------------------- Various -------------------------
// --------------------------------------------------------------

import autosize from 'autosize';
window.autosize = autosize;

import sortable from './html5sortable';
window.sortable = sortable;
// $.fn.sortable = sortable;

import { number_pages } from './number_pages';
window.number_pages = number_pages;

import { sorter_ready } from "./badok_sortable";
window.sorter_ready = sorter_ready;
document.addEventListener("DOMContentLoaded", () => sorter_ready());

// --------------------------------------------------------------
// --------------------- helper_functions.js --------------------
// --------------------------------------------------------------

import * as helper_functions from './helper_functions';
window.upload_file_drag_drop = helper_functions.upload_file_drag_drop;
window.generate_pdf_from_table = helper_functions.generate_pdf_from_table;
window.copy_text_to_clipboard = helper_functions.copy_text_to_clipboard;

// --------------------------------------------------------------
// ---------------------- docus_common.js -----------------------
// --------------------------------------------------------------
import * as docus_common from './docus_common';

window.docus_checklist_eval = docus_common.docus_checklist_eval;
window.count_docu_checkboxes_checked = docus_common.count_docu_checkboxes_checked;
window.count_docu_checkboxes_checked_except_none = docus_common.count_docu_checkboxes_checked_except_none;
window.get_checkboxes_results = docus_common.get_checkboxes_results;
window.cancel_all_docus_options_for_none = docus_common.cancel_all_docus_options_for_none;
window.cancel_docus_none_option = docus_common.cancel_docus_none_option;
window.evaluate_mandatory_fields = docus_common.evaluate_mandatory_fields;
window.findDuplicateIds = docus_common.findDuplicateIds;
window.global_docus_check_datetime_fields = docus_common.global_docus_check_datetime_fields;
window.check_docu_model_date = docus_common.check_docu_model_date;


// --------------------------------------------------------------
// ------------------------- Redfish.JS -------------------------
// --------------------------------------------------------------

import * as redfish from './redfish';

// ------------------- Person & Avatar -------------------
window.set_person_avatar = redfish.set_person_avatar;
window.set_h1_caption = redfish.set_h1_caption;
window.set_gendered_person_info = redfish.set_gendered_person_info;
window.bind_gender_watch = redfish.bind_gender_watch;
window.generateAvatarCircleFill = redfish.generateAvatarCircleFill;
window.applyAvatarPhoto = redfish.applyAvatarPhoto;
window.clearAvatarPhoto = redfish.clearAvatarPhoto;

// ------------------- UI Rendering ----------------------
window.paint_tr = redfish.paint_tr;
window.paint_fieldsets = redfish.paint_fieldsets;
window.set_all_fieldset_inner_to = redfish.set_all_fieldset_inner_to;
window.paint_overlap_region = redfish.paint_overlap_region;
window.highlightElement = redfish.highlightElement;
window.popup_window = redfish.popup_window;
window.dim_the_form = redfish.dim_the_form;
window.dimmed_element = redfish.dimmed_element;

// ------------------- Filters ---------------------------
window.sortable_ready = redfish.sortable_ready;
window.set_all_filter_handler_icons = redfish.set_all_filter_handler_icons;
window.set_filter_handler = redfish.set_filter_handler;
window.set_filter_handler_icon = redfish.set_filter_handler_icon;
window.journal_filter_group = redfish.journal_filter_group;
window.has_journal_filter = redfish.has_journal_filter;
window.journal_filter_hidden_selector = redfish.journal_filter_hidden_selector;
window.has_filter = redfish.has_filter;

// ------------------- AJAX Lookups ----------------------
window.ajax_lookup_access_certificate_valid_to = redfish.ajax_lookup_access_certificate_valid_to;
window.ajax_get_access_certificate_filename = redfish.ajax_get_access_certificate_filename;
window.employmentLookupParams = redfish.employmentLookupParams;
window.ajaxLookupEmployments = redfish.ajaxLookupEmployments;

// ------------------- Date & Time -----------------------
window.auto_correct_two_digit_year_in_birthdate = redfish.auto_correct_two_digit_year_in_birthdate;
window.auto_correct_two_digit_year_in_date = redfish.auto_correct_two_digit_year_in_date;

// ------------------- Utility & DOM Helpers -------------
window.compressArray = redfish.compressArray;
window.num_form_eval_errors = redfish.num_form_eval_errors;
window.GetProperty = redfish.GetProperty;
window.is_visible = redfish.is_visible;
window.docu_deactivator = redfish.docu_deactivator;
window.format_ajax_compliant = redfish.format_ajax_compliant;
window.encodeRFC5987ValueChars = redfish.encodeRFC5987ValueChars;
window.ElementHide = redfish.ElementHide;
window.ElementShow = redfish.ElementShow;
window.InnerHTML = redfish.InnerHTML;
window.escapeRegExp = redfish.escapeRegExp;
window.replaceAll = redfish.replaceAll;
window.Left = redfish.Left;
window.Right = redfish.Right;
window.format_comma = redfish.format_comma;
window.filename_to_title = redfish.filename_to_title;
window.compound_id = redfish.compound_id;
window.normalizeButtons = redfish.normalizeButtons;
window.disableUiButtons = redfish.disableUiButtons;
window.enableUiButtons = redfish.enableUiButtons;
window.is_true = redfish.is_true;

// ------------------- UI Busy State ---------------------
window.SetPageToBusy = redfish.SetPageToBusy;
window.SetPageToIdle = redfish.SetPageToIdle;
window.auto_hide = redfish.auto_hide;
window.AutoHideFlashZone = redfish.AutoHideFlashZone;

// ------------------- Task Overlap Visuals --------------
window.reset_overlap_images = redfish.reset_overlap_images;
window.focus_overlap_image = redfish.focus_overlap_image;
window.reset_overlap_radio = redfish.reset_overlap_radio;

// ------------------- Storno --------------------------
window.azStornoReverse = redfish.azStornoReverse; // 260721nrai
window.azStornoRequestOpen = azStornoRequestOpen; // 260810nrai

// --------------------------------------------------------------
// ------------------- Time_Records_Common.JS -------------------
// --------------------------------------------------------------
import * as timeRecordsCommon from './time_records_common';

// Expose date/time utilities
window.init_datetimepicker = timeRecordsCommon.init_datetimepicker;
window.compose_datetime = timeRecordsCommon.compose_datetime;
window.moment_correct_dauer_for_dst = timeRecordsCommon.moment_correct_dauer_for_dst;
window.calculate_dauer = timeRecordsCommon.calculate_dauer;
window.record_is_all_day = timeRecordsCommon.record_is_all_day;

window.moment_date = timeRecordsCommon.moment_date;
window.moment_time = timeRecordsCommon.moment_time;
window.moment_datetime = timeRecordsCommon.moment_datetime;
window.moment_date_validation = timeRecordsCommon.moment_date_validation;
window.moment_time_validation = timeRecordsCommon.moment_time_validation;
window.moment_datetime_validation = timeRecordsCommon.moment_datetime_validation;
window.moment_date_range_validation = timeRecordsCommon.moment_date_range_validation;
window.moment_time_range_validation = timeRecordsCommon.moment_time_range_validation;
window.moment_datetime_range_validation = timeRecordsCommon.moment_datetime_range_validation;
window.moment_date_in_year_validation = timeRecordsCommon.moment_date_in_year_validation;
window.moment_get_duration = timeRecordsCommon.moment_get_duration;
window.moment_set_weekday = timeRecordsCommon.moment_set_weekday;
window.moment_days_in_year = timeRecordsCommon.moment_days_in_year;

window.lastSundayOfMonth = timeRecordsCommon.lastSundayOfMonth;

// UI Helpers
window.set_time_record_form_submit_button = timeRecordsCommon.set_time_record_form_submit_button;
window.set_clients_select_list_to_multiple = timeRecordsCommon.set_clients_select_list_to_multiple;
window.set_employees_select_list_to_multiple = timeRecordsCommon.set_employees_select_list_to_multiple;
window.set_person_select_list_to_multiple = timeRecordsCommon.set_person_select_list_to_multiple;
window.extractInstitutionId = timeRecordsCommon.extractInstitutionId;
window.clientSelectIsSelect = timeRecordsCommon.clientSelectIsSelect;
window.clientSelectOhneKlientCandidates = timeRecordsCommon.clientSelectOhneKlientCandidates;
window.pickOhneKlientCompound = timeRecordsCommon.pickOhneKlientCompound;
window.applyOhneKlientSelection = timeRecordsCommon.applyOhneKlientSelection;
window.adapt_client_list_for_task = timeRecordsCommon.adapt_client_list_for_task;
window.syncCurrentInstitutionWithSelectedClient = timeRecordsCommon.syncCurrentInstitutionWithSelectedClient;
window.hide_elements_for_task = timeRecordsCommon.hide_elements_for_task;
window.set_workdays = timeRecordsCommon.set_workdays;
window.check_for_available_date = timeRecordsCommon.check_for_available_date;
window.get_available_docus = timeRecordsCommon.get_available_docus;
window.get_ziele_warning = timeRecordsCommon.get_ziele_warning;
window.get_docus_gascales_warning = timeRecordsCommon.get_docus_gascales_warning;
window.get_fehlkontakte_warning = timeRecordsCommon.get_fehlkontakte_warning;
window.get_contact_type = timeRecordsCommon.get_contact_type;
window.get_call_client_button = timeRecordsCommon.get_call_client_button;
window.get_client_data = timeRecordsCommon.get_client_data;
window.enable_edit_person_button = timeRecordsCommon.enable_edit_person_button;
window.enable_edit_client_button = timeRecordsCommon.enable_edit_client_button;
window.enable_edit_employee_button = timeRecordsCommon.enable_edit_employee_button;
window.cleanEmptySelect2Entries = timeRecordsCommon.cleanEmptySelect2Entries;

// 260721nrai: client-select helpers (used by ERB views / inline handlers)
window.clientSelectValues = timeRecordsCommon.clientSelectValues;
window.clientSelectFirstValue = timeRecordsCommon.clientSelectFirstValue;
window.clientSelectHasOhneKlient = timeRecordsCommon.clientSelectHasOhneKlient;
window.clientSelectListHasRealClients = timeRecordsCommon.clientSelectListHasRealClients;
window.updateClientInstitutionLabel = timeRecordsCommon.updateClientInstitutionLabel;
window.clientCompoundIsOhneKlient = timeRecordsCommon.clientCompoundIsOhneKlient;
window.clientCompoundIsRealClient = timeRecordsCommon.clientCompoundIsRealClient;
window.clearClientInstitutionSelect = timeRecordsCommon.clearClientInstitutionSelect;
window.setClientInstitutionSelectValue = timeRecordsCommon.setClientInstitutionSelectValue;
window.applySetClientSelectFromHidden = timeRecordsCommon.applySetClientSelectFromHidden;
window.resetClientSelectAfterJournalCreate = timeRecordsCommon.resetClientSelectAfterJournalCreate;
window.compoundIdPart = timeRecordsCommon.compoundIdPart;
window.ensureRecordInstitutionFromClient = timeRecordsCommon.ensureRecordInstitutionFromClient;
window.noruzStoredSecondsForTimeField = timeRecordsCommon.noruzStoredSecondsForTimeField;

// TimeRecord-specific AJAX interactions
window.ajax_set_session_pref = timeRecordsCommon.ajax_set_session_pref;
window.ajax_edit_time_record = timeRecordsCommon.ajax_edit_time_record;
window.ajax_refresh_journal = timeRecordsCommon.ajax_refresh_journal;
window.ajax_get_tasks = timeRecordsCommon.ajax_get_tasks;
window.ajax_lookup_client = timeRecordsCommon.ajax_lookup_client;
window.ajax_lookup_institution = timeRecordsCommon.ajax_lookup_institution;
window.ajax_lookup_employee = timeRecordsCommon.ajax_lookup_employee;
window.ajax_lookup_project = timeRecordsCommon.ajax_lookup_project;
window.ajax_lookup_task = timeRecordsCommon.ajax_lookup_task;
window.ajax_lookup_task_type_ids = timeRecordsCommon.ajax_lookup_task_type_ids; // 260721nrai
window.ajax_lookup_contact_type = timeRecordsCommon.ajax_lookup_contact_type;
window.ajax_lookup_contact_status = timeRecordsCommon.ajax_lookup_contact_status;
window.ajax_lookup_fahrzeug = timeRecordsCommon.ajax_lookup_fahrzeug;
window.ajax_lookup_institution_filter = timeRecordsCommon.ajax_lookup_institution_filter;

// --------------------------------------------------------------
// ------------------- time_records_msb.js -------------------
// --------------------------------------------------------------
import * as timeRecordsMsb from './time_records_msb';

window.reset_dauer = timeRecordsMsb.reset_dauer;
window.reset_values = timeRecordsMsb.reset_values;
window.reset_all_values = timeRecordsMsb.reset_all_values;
window.reset_hidden_values = timeRecordsMsb.reset_hidden_values;
window.calculate_vorort_dauer = timeRecordsMsb.calculate_vorort_dauer;
window.check_pause_between = timeRecordsMsb.check_pause_between;
window.check_betreuungszeiten = timeRecordsMsb.check_betreuungszeiten;
window.check_for_open_time_windows = timeRecordsMsb.check_for_open_time_windows;
window.check_for_completeness = timeRecordsMsb.check_for_completeness;
window.prepare_msb_form_values = timeRecordsMsb.prepare_msb_form_values;
window.time_changed = timeRecordsMsb.time_changed;

// --------------------------------------------------------------
// ---------------------- genoeasy_genogram.js ------------------
// --------------------------------------------------------------
import './genoeasy_genogram';

// 260703nrai: live message toasts
document.addEventListener('DOMContentLoaded', function () {
  if (window.initMessagesPoll) {
    window.initMessagesPoll();
  }
  initHeaderBecomeUser();
  initPersonHoverMenu();
  initPersonClientMatrix();
  initPersonListLazyLoading();
  initEmployeeAvatarForm();
  initDocuWindowLeadRequest();
  initAzReversalRequest();
  initAzVerifyPdf();
  initAzSaldoHover();
  initVacationRequest();
  initTodosUi();
  initErrorReportsUi();
  initInstitutionResponsibilityFilters();
  initClientResponsibilityMarks();
  initCurrentUsersPage();
  helper_functions.init_copy_to_clipboard();
});

window.crToggleMarks = crToggleMarks;
window.crMarksSubmit = crMarksSubmit;
window.toggle_marks = toggle_marks;

window.initInstitutionResponsibilityFilters = initInstitutionResponsibilityFilters;

window.vacationRequestOpen = vacationRequestOpen;
window.filter_time_record_workflow = filter_time_record_workflow;
window.azVerifyPdfModalOpen = azVerifyPdfModalOpen;
window.azVerifyPdfModalClose = azVerifyPdfModalClose;